import type { Post } from "shared/types/post";
import type { ApprovalBoardPost } from "./approval-post-state";

type ApprovalBoardPostAccountFields = Pick<Post, "accountIds"> & {
  accountId?: string;
};

export function getApprovalBoardPostAccountIds(
  post: ApprovalBoardPostAccountFields
): string[] {
  if (post.accountIds?.length) return post.accountIds;
  return post.accountId ? [post.accountId] : [];
}

export function toLegacyApprovalPost(post: ApprovalBoardPost): Post {
  return {
    ...(post as Post),
    accountIds: getApprovalBoardPostAccountIds(post),
  };
}

export function toEditableLegacyApprovalPost(post: ApprovalBoardPost): Post {
  const scheduledAt = post.start || post.when;
  const legacyPost = toLegacyApprovalPost(post);
  legacyPost.accountIds = post.accountId
    ? [post.accountId]
    : getApprovalBoardPostAccountIds(post);
  legacyPost.nextRunAt = post.nextRunAt;
  legacyPost.when = scheduledAt as Post["when"];
  legacyPost.lastRunAt = (post.lastRunAt || post.start) as Post["lastRunAt"];
  return legacyPost;
}
